<header class="bl-content-header">
  <div class="bl-wrapper bl-wrapper--padding-header">
  
    <nav class="bl-menu">
      <div class="bl-menu__wrapper">

        <ul class="bl-menu__list">
          <li>
            <img
             
              src="../../../../assets/image/logo-luca 2.png"
              alt="logo Luca"
              style="width: 200px; height: 50px;"
            />
          </li>
          <li *ngFor="let item of menu; let i = index" class="bl-menu__item">
            <a
              *ngIf="activeNav"
              class="bl-menu__link"
              [routerLink]="item.link"
              routerLinkActive="bl-menu__link--active"
              title="{{ item.field }}"
              [ngClass]="{
                'bl-menu__link--step-selected':
                  steps && steps[i] && steps[i].stepSelected ? true : false,
                'bl-menu__link--disabled': steps && steps[i] && steps[i].disabled ? true : false
              }"
            >
              <i [class]="item.icon"></i>
              <span *ngIf="activeNav" class="bl-menu__text" [attr.data-attr]="item.field">{{
                item.field
              }}</span>

              <span
                *ngIf="activeNav"
                [ngClass]="{
                  'bl-menu__link--step-selected bl-menu__corner':
                    steps && steps[i] && steps[i].stepSelected ? true : false,
                  'bl-menu__link--disabled': steps && steps[i] && steps[i].disabled ? true : false
                }"
              >
              </span>
            </a>
          </li>

          <li *ngFor="let item of menu; let i = index" class="bl-menu__item">
            <a
              *ngIf="!activeNav"
              class="bl-menu__link"
              [routerLink]="item.link"
              routerLinkActive="bl-menu__link--active"
              title="{{ item.field }}"
              [ngClass]="{
                'bl-menu__link--step-selected':
                  steps && steps[i] && steps[i].stepSelected ? true : false,
                'bl-menu__link--disabled': steps && steps[i] && steps[i].disabled ? true : false
              }"
            >
              <i [class]="item.icon"></i>
              <span *ngIf="!activeNav" class="bl-menu__text" [attr.data-attr]="item.field">{{
                item.field
              }}</span>

              <span
                *ngIf="!activeNav"
                [ngClass]="{
                  'bl-menu__link--step-selected bl-menu__corner':
                    steps && steps[i] && steps[i].stepSelected ? true : false,
                  'bl-menu__link--disabled': steps && steps[i] && steps[i].disabled ? true : false
                }"
              >
              </span>
            </a>
          </li>

          <li *ngIf="canSearch" class="bl-menu__item">
            <bid-search-historical></bid-search-historical>
          </li>
        </ul>
      </div>

      <ul class="bl-menu__list bl-menu__list--sub">
        <li *ngIf="activeNav" class="bl-menu__item">
          <!--a
            class="bl-menu__link--dark"
            routerLink="/dashboard"
            routerLinkActive="bl-menu__link--active"
          >
            <i class="far fa-chart-bar"></i> Analytics
          </a-->
          <bid-menu-dashboard></bid-menu-dashboard>
        </li>

        <li *ngIf="activeNav" class="bl-menu__item">
          <bid-menu-role></bid-menu-role>
        </li>

        <li class="bl-menu__item"><bid-user-button></bid-user-button></li>
      </ul>
    </nav>
  </div>
</header>
<!--[ngClass]="{'disabled-menu': steps[i].disabled === true ? true : false }" -->
<!-- routerLinkActive="bl-menu__link--active" -->
